<template>
	<div class="errors">
		<transition-group name="error-fade">
			<Error
				v-for="(error, index) in errors"
				:key="index"
				:message="error"
				:index="index"
			/>
		</transition-group>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Error from "./Error";
export default {
	computed: {
		...mapGetters(["errors"]),
	},
	components: {
		Error,
	},
};
</script>

<style lang="scss" scoped>
.errors {
	position: absolute;
	width: 40%;
	max-width: 300px;
	min-height: 80px;
	bottom: 16px;
	left: 16px;
	.error-box {
		display: block;
		margin: 8px 0;
	}
}

.error-fade-enter-active,
.error-fade-leave-active {
	transition: all 0.4s ease;
}
.error-fade-enter-from,
.error-fade-leave-to {
	opacity: 0;
}

.error-fade-move {
	transition: transform 0.4s ease;
}
</style>
